"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.helpDocs = void 0;
var helpDocs = {
  name: 'help',
  category: 'Expression',
  syntax: ['help(object)', 'help(string)'],
  description: 'Display documentation on a function or data type.',
  examples: ['help(sqrt)', 'help("complex")'],
  seealso: []
};
exports.helpDocs = helpDocs;